const $ = window.kzs.$;

export const addOutBoundToATag = (re: RegExp): HTMLElement[] => {
  const outboundedElements: HTMLElement[] = [];
  $("a").each((_, e) => {
    if (($(e).attr("href") || "").match(re)) {
      $(e).attr("data-kz-track", "outbound");
      outboundedElements.push(e);
    }
  });
  return outboundedElements;
};
